import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarMenus from '../components/SidebarMenus';
import Header from '../components/Header';
import { useNotifications } from '../context/NotificationContext';
import '../assets/styles/dashboard.css';
import '../assets/styles/notifications.css';

const TYPE_META = {
  ride_accepted: { icon: '✓', className: 'notif-icon--success' },
  ride_assigned: { icon: '🚗', className: 'notif-icon--info' },
  settlement: { icon: '$', className: 'notif-icon--payment' },
  ride_cancelled: { icon: '✕', className: 'notif-icon--danger' },
  ride_canceled_by_agency: { icon: '✕', className: 'notif-icon--danger' },
  ride_completed: { icon: '✓', className: 'notif-icon--success' },
  ride_started: { icon: '🚗', className: 'notif-icon--info' },
};

const RIDE_TYPES = [
  'ride_accepted',
  'ride_assigned',
  'ride_cancelled',
  'ride_canceled_by_agency',
  'ride_completed',
  'ride_started',
];

function formatRelativeTime(ts) {
  const time = new Date(ts).getTime();
  if (Number.isNaN(time)) return '';

  const diffMs = Date.now() - time;
  const mins = Math.floor(diffMs / 60000);

  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins} min ago`;

  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr ago`;

  return new Date(time).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

const Notifications = () => {
  const navigate = useNavigate();
  const {
    notifications,
    unreadCount,
    loading,
    markAllRead,
    markOneRead,
  } = useNotifications();

  const agencyData = JSON.parse(localStorage.getItem('agencyData') || '{}');
  const partnerName = agencyData.companyName || 'Partner';
  const partnerEmail = agencyData.email || '';
  const initials = partnerName
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  const handleClick = (item) => {
    console.log("item clicked: ",item);
    if (!item.isRead) {
      markOneRead(item._id);
    }

    if (RIDE_TYPES.includes(item.type) && item.rideId) {
      navigate(`/booking-details?id=${item.rideId}`);
    }
  };

  return (
    <div className="dashboard-layout">
      <SidebarMenus
        partnerName={partnerName}
        partnerEmail={partnerEmail}
        notificationCount={unreadCount}
      />

      <main className="dashboard-main">
        <Header
          title="Notifications"
          search={false}
          bell={true}
          partnerName={partnerName}
          initials={initials}
          searchPlaceholder="Search bookings, customers..."
        />

        <section className="notifications-page">
          <div className="notifications-toolbar">
            <p className="notifications-count">
              {unreadCount} unread notification{unreadCount === 1 ? '' : 's'}
            </p>
            {unreadCount > 0 && (
              <button
                type="button"
                className="mark-all-read"
                onClick={markAllRead}
              >
                ✓ Mark all read
              </button>
            )}
          </div>

          {loading ? (
            <div className="notifications-empty">Loading notifications…</div>
          ) : notifications.length === 0 ? (
            <div className="notifications-empty">No notifications yet.</div>
          ) : (
            <ul className="notifications-list">
              {notifications.map((item) => {
                const meta = TYPE_META[item.type] || TYPE_META.ride_accepted;

                return (
                  <li
                    key={item._id}
                    className={`notification-card${item.isRead ? '' : ' is-unread'}`}
                    onClick={() => handleClick(item)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleClick(item);
                      }
                    }}
                  >
                    <div className={`notif-icon ${meta.className}`}>{meta.icon}</div>
                    <div className="notif-body">
                      <h3 className="notif-title">{item.title}</h3>
                      <p className="notif-message">{item.message}</p>
                    </div>
                    <div className="notif-meta">
                      <span className="notif-time">
                        {formatRelativeTime(item.createdAt)}
                      </span>
                      {!item.isRead && (
                        <span className="notif-dot" aria-label="Unread" />
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </section>
      </main>
    </div>
  );
};

export default Notifications;